import React, { FunctionComponent } from 'react';
import classnames from 'classnames';
import withStyles from 'react-jss';
import { useFormContext } from 'react-hook-form';

import { ClassProp } from 'helpers/types';
import { Theme } from 'config';

import FormErrors from '../FormError';

type Styles = ClassProp<ReturnType<typeof styles>>;

type Props = {
  classes: Styles;
  type: string;
  name: string;
  placeholder?: string;
  label?: string;
  register: any;
  size?: string;
  tabIndex?: number;
};

const styles = (theme: Theme) => ({
  container: {
    width: '100%',
    marginTop: '.25rem !important',
    justifyContent: 'center !important',
  },
  small: {
    width: '31%',
    marginRight: '.55rem',
  },
  medium: {
    width: '48%',
    marginRight: '.55rem',
  },
  large: {
    width: '100%',
  },
  fieldContainer: {},
  fieldLabel: {
    color: '#646464 !important',
    fontSize: '.875rem !important',
    fontWeight: '500 !important',
    margin: '0 0 .30rem 0',
    display: 'block !important',
  },
  fieldArea: {
    border: '.0625rem solid rgba(34,36,38,.15)',
    color: 'rgba(0,0,0,.87)',
    borderRadius: '.28571429rem',
    boxShadow: '0 0 0 0 transparent inset',
    transition: 'color .1s ease,border-color .1s ease',
    backgroundColor: '#fff',
    resize: 'both',
    display: 'flex',
    flex: '1 0 auto',
    minHeight: '8rem',
    minWidth: '38rem',
    textAlign: 'left',
    margin: '0',
    outline: '0',
    tapHighlightColor: 'rgba(255,255,255,0)',
    lineHeight: '1.21em',
    padding: '.67857143rem 1rem',
    fontSize: '1rem',
  },
  fieldError: {},
});

const FormTextArea: FunctionComponent<Props> = ({
  classes,
  label,
  name,
  tabIndex = 0,
  size,
  register,
  ...rest
}) => {
  const { errors } = useFormContext();

  return (
    <div
      className={classnames(classes.container, {
        [classes.small]: size === 'small',
        [classes.medium]: size === 'medium',
        [classes.large]: size === 'large',
      })}
    >
      <label htmlFor={name}>
        <span className={classes.fieldLabel}>{label}</span>
        <textarea
          className={classes.fieldArea}
          id={name}
          tabIndex={tabIndex}
          name={name}
          {...rest}
          ref={register}
        />
      </label>
      {errors && <FormErrors name={name} errors={errors} />}
    </div>
  );
};
export default withStyles(styles)(FormTextArea);
